import {
  PriorityHighestIcon,
  PriorityHighIcon,
  PriorityNormalIcon,
} from '@moia-dev/pace-icons'
import type { AlertSeverity } from './getAlertSeverity'

export const getAlertIconComponent = (severity: AlertSeverity) => {
  switch (severity) {
    case 'Highest':
      return PriorityHighestIcon
    case 'High':
      return PriorityHighIcon
    case 'Normal':
      return PriorityNormalIcon
  }
}
